import React from 'react';
import { finalCta } from '../data/content';
import { CtaButton } from './CtaButton';

/** Last push before the footer (modeled on the Managers landing) */
export function FinalCta() {
  return <section aria-labelledby="final-title" className="bg-mist py-12 md:py-20" data-id="element-97" data-mp="19fgx47jk9i91">
      <div className="mx-auto max-w-[780px] px-5 text-center md:px-8" data-id="element-98" data-mp="15ddija1lhxjj">
        <p className="font-display text-[12px] font-extrabold tracking-[0.14em] text-coral-ink" data-id="element-99" data-mp="15fghijkq710e">{finalCta.eyebrow}</p>
        <h2 id="final-title" className="mt-3 font-display text-[1.9rem] font-black uppercase leading-[1.08] tracking-tight text-brand sm:text-[2.4rem] md:text-[2.8rem]" data-id="element-100" data-mp="1jasekxmct3kh">
          {finalCta.title}
        </h2>
        <p className="mx-auto mt-4 max-w-[560px] text-[17px] leading-relaxed text-ink/75" data-id="element-101" data-mp="1o43l0xn97ibv">{finalCta.text}</p>
        <div className="mx-auto mt-8 flex max-w-[460px] justify-center" data-id="element-102" data-mp="22339o5arnx81">
          <CtaButton microcopy={finalCta.microcopy} align="center" data-id="element-103" data-mp="2219zwh4uwwvt" />
        </div>
      </div>
    </section>;
}